import {parseISO, isValid} from "date-fns";

const safeParseISO = (stringISO, invalidDate = new Date(NaN)) => {
    let date = null;
    try {
        date = parseISO(stringISO);
    } catch (e) {
        console.error(`Unable to parse the given iso date: ${stringISO}. Got:`, e);
    }
    return isValid(date) ? date : invalidDate;
};

export {safeParseISO}